import { render, staticRenderFns } from "./AdminBaseView.vue?vue&type=template&id=336c90b1&scoped=true&"
import script from "./AdminBaseView.vue?vue&type=script&lang=js&"
export * from "./AdminBaseView.vue?vue&type=script&lang=js&"
import style0 from "./AdminBaseView.vue?vue&type=style&index=0&id=336c90b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c90b1",
  null
  
)

export default component.exports